import { getNumberFormat } from './getNumberFormat';

const formatter = getNumberFormat('en', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

/**
 * Formats a number as a US dollar amount with 2 digits of precision
 * @param value
 * @returns
 */
export const formatDollarsStandard = (input: number): string =>
    formatter.format(input);
